<template>
  <v-container mb-12 mt-5>
    <v-row>
      <v-col sm="5" md="6" offset-lg="0">
        <h1>Record Folders</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <hr />
    <v-row>
      <v-col>
        <RecordFolderCreateModal/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <RecordNavigation :filing="filing" :category="category" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row>
          <v-col
            cols="12"
            lg="3"
            sm="6"
            md="4"
            v-for="(record) in allRecordFolders"
            :key="record.id"
          >
            <v-card elevation="3" hover @dblclick="goTo(record.id)">
              <v-card-text class="text-wrap">
                <v-icon class="mr-2">mdi-folder-multiple</v-icon>
                {{record.title}}
              </v-card-text>
              <v-card-subtitle>{{ record.name }} - {{ record.description }}</v-card-subtitle>
                <v-card-text>
                  Security: {{ record.security_level }}
                </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn icon>
                  <v-icon @click="editItem(record)">mdi-lead-pencil</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon @click="deleteItem(record.id)">mdi-trash-can</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon @click="moveItem(record.id)">mdi-folder-move</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Update Details</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="editedItem.title" label="Title"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="editedItem.security_level"
                        :items="security_level_items"
                        label="Security Level"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" v-if="errorMessage">
                      <h3 class="text-center red--text">{{ errorMessage }}</h3>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="categoryDialog" scrollable max-width="300px">
            <v-card>
              <v-card-title>
                <v-btn icon v-if="filingOpened" class="ml-n5">
                  <v-icon @click="backToFilingList()">mdi-arrow-left</v-icon>
                </v-btn>
                Select {{ (filingOpened) ? "Category" : "Filing" }}
              </v-card-title>
              <v-divider></v-divider>
              <v-list v-if="!filingOpened">
                <v-list-item
                  v-for="(filing) in categoriesNavigation"
                  :key="filing.id"
                  @dblclick="open(filing.id)"
                  @click="filingSelected = filing.id"
                >
                  <v-list-item-title class="list-item" :class="{ active:filing.id == filingSelected}">{{ filing.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item
                  v-for="(category) in listCategories"
                  :key="category.id"
                  @dblclick="moveToCategory(category.id)"
                  @click="categorySelect = category.id"
                >
                  <v-list-item-title class="list-item" :class="{ active:category.id == categorySelect}">{{ category.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
                <v-btn v-if="!filingOpened" color="blue darken-1" text @click="open()">Open</v-btn>
                <v-btn v-else color="blue darken-1" text @click="moveToCategory(false)">Move</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RecordNavigation from "../../components/RecordNavigation";
import RecordFolderCreateModal from '../../components/RecordFolderCreateModal';
import Swal from 'sweetalert2';

export default {
  name: "RecordFolders",
  components: {
    RecordNavigation,
    RecordFolderCreateModal,
  },
  data() {
    return {
      singleSelect: false,
      selected: [],
      search: "",
      dialog: false,
      categoryDialog: false,
      categoryId: this.$route.params.id,
      errorMessage: null,
      filing: {
        id: "",
        title: "",
      },
      category: {
        id: "",
        title: "",
      },
      folder: "",
      editedIndex: -1,
      security_level_items: ['Low', 'Moderate', 'High'],
      security_level: '',
      editedItem: {
        title: '',
        name: '',
        description: '',
        security_level: 'Low'

      },
      defaultItem: {
        title: '',
        name: '',
        security_level: 'Low'
      },
      moveFolder: undefined,
      categorySelect: false,
      filingSelected: null,
      filingOpened: null,
      listCategories: [{
        id: 1,
        title: "hello"
      }, {
        id: 2,
        title: "Wordld"
      }],
    };
  },
  methods: {
    ...mapActions(["fetchCategoriesNavigation", "fetchFolders", "updateFolder", "deleteRecordFolder", "updateFolderCategory"]),
    goTo(id) {
      location.replace(`/records/folders/${id}`);
    },
    editItem(item) {
      this.errorMessage = null;
      this.editedIndex = this.allRecordFolders.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false;
      this.categoryDialog = false;
      this.filingSelected = null;
      this.filingOpened = null;
      this.listCategories = [];
      this.errorMessage = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    async save () {
      if (this.editedIndex > -1) {
        const update = await this.updateFolder(this.editedItem);
        if(update.error) {
          if(update.status == 400) this.errorMessage = update.message;
          else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Internal Server Error',
            })
          }
        } else if(update) {
          this.showSuccess = true;
          this.editedItem.name = '';
          this.editedItem.title = '';
          this.editedItem.description = '';
          this.editedItem.security_level = 'Low';
          this.dialog = false;
          this.errorMessage = null;
          this.close()
        }
      }
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

          this.deleteRecordFolder(id)
            .then(() => {
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            })
        }
      })
    },
    move(){
      if(!this.categorySelect) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'You need to select a category',
        })
      }
    },
    moveItem(folderId) {
      this.moveFolder = folderId;
      this.categoryDialog = true;
    },
    moveToCategory(categoryId) {
      const body = {
        category_id: (categoryId) ? categoryId : this.categorySelect,
        folder_id: this.moveFolder
      }
      this.updateFolderCategory(body)
        .then(() => {
          this.categoryDialog = false;
          this.moveFolder = null;
          this.categorySelect = undefined;
          this.filingSelected = null;
          this.filingOpened = null;
          this.listCategories = [];
        })
    },
    open(filingId) {
      if(!filingId) this.filingOpened = this.filingSelected;
      else {
        this.filingSelected = filingId;
        this.filingOpened = filingId;
      }
      const index = this.categoriesNavigation.findIndex(filing => filing.id === this.filingSelected);
        if(index !== -1) {
          this.listCategories = this.categoriesNavigation[index].record_categories;
        }
    },
    backToFilingList() {
      this.filingSelected = null;
      this.filingOpened = null;
      this.listCategories = [];
    }
  },
  computed: {
    ...mapGetters(["allRecordFolders", "categoriesNavigation"]),
    navigationList: function () {
      return this.fetchCategoriesNavigation();
    }
  },
  async created() {
    let response = await this.fetchFolders(this.categoryId);
    this.fetchCategoriesNavigation();
    this.filing.id = response.record_filing.id;
    this.filing.title = response.record_filing.title;
    this.category.id = response.id;
    this.category.title = response.title;
    this.categorySelect = undefined;
  },
};
</script>

<style scoped>
  .list-item {
    cursor: pointer;
    padding-left: 10px;
  }

  .list-item.active {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #dfdfdf;
  }

  .list-item:hover {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #f5f5f5;
  }
</style>